<template>
  <div class="app-container">
    <el-carousel class="home-carousel" :interval="5000" arrow="never">
      <el-carousel-item v-for="(item, index) in bannerList" :key="index">
        <div class="carousel-box">
          <div class="carousel-bg">
            <el-image class="carousel-img" fit="cover" :src="item.bgImageUrl" />
          </div>
          <div v-if="item.textPosition === 0" class="carousel-content">
            <div class="state">{{ item.title }}</div>
            <div class="title">{{ item.advertising }}</div>
            <div class="desc">{{ item.subTitle }}</div>
            <div v-if="item.softWinVersion !== ''" class="num">
              {{ item.softWinVersion }} ｜{{
                renderSize(item.softWinSize)
              }}｜{{item.softWinTime}}
            </div>
            <div v-else>
              <div class="num">
                {{ item.softAppleVersion }} ｜{{
                  renderSize(item.softAppleSize)
                }}｜{{item.softAppleTime}}
              </div>
              <div class="num">
                {{ item.softAndroidVersion }} ｜{{
                  renderSize(item.softAndroidSize)
                }}｜{{item.softAndroidTime}}
              </div>
            </div>
            <a
              :href="item.softWinPath"
              v-if="item.softWinVersion !== ''"
              class="button-box"
            >
              <div class="button-img">
                <img class="image" src="@/assets/icon_windows_fill.png" />
              </div>
              <div class="load-now">立即下载</div>
            </a>
            <div v-else class="botom-app-box">
              <div class="app-qr">
                <img class="image" :src="item.qrcode" />
              </div>
              <div class="banner-app-item-box">
                <a
                  :href="item.softApplePath"
                  class="banner-app-item-top"
                >
                  <div class="item-img">
                    <img
                      class="image"
                      src="@/assets/icon_home_banner_down.png"
                    />
                  </div>
                  <div class="name">iPhone</div>
                </a>
                <a
                  :href="item.softAndroidPath"
                  class="banner-app-item-bottom"
                >
                  <div class="item-img">
                    <img
                      class="image"
                      src="@/assets/icon_home_banner_down.png"
                    />
                  </div>
                  <div class="name">Android</div>
                </a>
              </div>
            </div>
          </div>
          <div v-else class="carousel-content-right">
            <div class="state">{{ item.title }}</div>
            <div class="title">{{ item.advertising }}</div>
            <div class="desc">{{ item.subTitle }}</div>
            <div v-if="item.softWinVersion !== ''" class="num">
              {{ item.softWinVersion }} ｜{{
                renderSize(item.softWinSize)
              }}｜{{item.softWinTime}}
            </div>
            <div v-else>
              <div class="num">
                {{ item.softAppleVersion }} ｜{{
                  renderSize(item.softAppleSize)
                }}｜{{item.softAppleTime}}
              </div>
              <div class="num">
                {{ item.softAndroidVersion }} ｜{{
                  renderSize(item.softAndroidSize)
                }}｜{{item.softAndroidTime}}
              </div>
            </div>
            <a
              :href="item.softWinPath"
              v-if="item.softWinVersion !== ''"
              class="button-box"
            >
              <div class="button-img">
                <img class="image" src="@/assets/icon_windows_fill.png" />
              </div>
              <div class="load-now">立即下载</div>
            </a>
            <div v-else class="botom-app-box">
              <div class="app-qr">
                <img class="image" :src="item.qrcode" />
              </div>
              <div class="banner-app-item-box">
                <a
                  :href="item.softApplePath"
                  class="banner-app-item-top"
                >
                  <div class="item-img">
                    <img
                      class="image"
                      src="@/assets/icon_home_banner_down.png"
                    />
                  </div>
                  <div class="name">iPhone</div>
                </a>
                <a
                  :href="item.softAndroidPath"
                  class="banner-app-item-bottom"
                >
                  <div class="item-img">
                    <img
                      class="image"
                      src="@/assets/icon_home_banner_down.png"
                    />
                  </div>
                  <div class="name">Android</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div v-for="(item, index) in mainList" :key="index">
      <div v-if="item.typeName === 'text'" class="text-box">
        <div class="title">{{ item.title }}</div>
        <div class="desc">{{ item.subTitle }}</div>
      </div>
      <div v-if="item.typeName === 'imgMark'" class="icon-box">
        <div
          class="icon-item"
          v-for="(it, ind) in item.imageTextList"
          :key="ind"
        >
          <div class="image-box">
            <img class="image" :src="it.imageUrl" />
          </div>
          <div class="icon-text-box">
            <div class="name">{{ it.title }}</div>
            <div class="desc">{{ it.subTitle }}</div>
          </div>
        </div>
      </div>
      <div v-if="item.typeName === 'imgText'" class="graphic-content">
        <div v-if="item.position === 1" class="graphic-left-box">
          <div class="image-box">
            <img class="image" :src="item.imageUrl" />
          </div>
          <div class="text-box">
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.subTitle }}</div>
          </div>
        </div>
        <div v-if="item.position === 0" class="graphic-right-box">
          <div class="text-box">
            <div>
              <div class="title">{{ item.title }}</div>
              <div class="desc">{{ item.subTitle }}</div>
            </div>
          </div>
          <div class="image-box">
            <img class="image" :src="item.imageUrl" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHomeScreen, getHomePoster } from "@/api/home";
import { renderSize } from "@/utils/index";
export default {
  name: "Home",
  data() {
    return {
      bannerList: [],
      mainList: [],
      renderSize,
    };
  },
  mounted() {
    this._getHomeScreen();
    this._getHomePoster();
  },
  methods: {
    //分屏
    _getHomeScreen() {
      getHomeScreen()
        .then((res) => {
          const { data } = res;
          this.mainList = [...data];
        })
        .catch((res) => {})
        .finally(() => {});
    },
    //banner
    _getHomePoster() {
      getHomePoster()
        .then((res) => {
          const { data } = res;
          this.bannerList = [...data];
        })
        .catch((res) => {})
        .finally(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  margin-top: -120px;
  padding-bottom: 120px;

  .text-box {
    margin-top: 80px;
    text-align: center;
    .title {
      color: #333333;
      font-size: 36px;
      font-weight: 700;
    }
    .desc {
      font-size: 18px;
      margin-top: 8px;
      color: #666666;
    }
  }
  .icon-box {
    margin: 0 auto;
    margin-top: 34px;
    display: flex;
    justify-content: center;
    flex-flow: wrap;
    width: 1440px;
    .icon-item {
      margin-top: 38px;
      margin-left: 100px;
      margin-right: 100px;
      text-align: center;
      width: 160px;
      .image-box {
        .image {
          width: 120px;
          height: 102px;
        }
      }
      .icon-text-box {
        margin-top: 5px;
        .name {
          font-size: 24px;
          color: #333333;
          font-weight: 700;
        }
        .desc {
          color: #666666;
          font-size: 16px;
          margin-top: 2px;
        }
      }
    }
  }
  .graphic-content {
    margin-top: 65px;
    .graphic-left-box {
      display: flex;
      // margin-top: 85px;
      align-items: center;
      .image-box {
        flex: 1;
        margin-right: 66px;
        // padding-top: 46px;
        // padding-bottom: 46px;
        padding-right: 25px;
        .image {
          width: 100%;
        }
      }
      .text-box {
        flex: 1;
        margin-left: 66px;
        text-align: left;
        margin-top: 0;
        overflow: hidden;
        .title {
          width: 560px;
          font-size: 50px;
          color: #333333;
          padding-bottom: 10px;
          font-weight: 400;
          text-align: left;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .desc {
          width: 560px;
          font-size: 20px;
          color: #666666;
          line-height: 40px;
          white-space: pre-wrap;
        }
      }
    }
    .graphic-right-box {
      display: flex;
      // margin-top: 85px;
      align-items: center;
      .text-box {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 66px;
        margin-top: 0;
        overflow: hidden;
        .title {
          width: 560px;
          font-size: 50px;
          color: #333333;
          padding-bottom: 10px;
          font-weight: 400;
          white-space: nowrap;
          text-align: left;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .desc {
          width: 560px;
          text-align: left;
          font-size: 20px;
          color: #666666;
          line-height: 40px;
          white-space: pre-wrap;
        }
      }
      .image-box {
        flex: 1;
        margin-left: 66px;
        // padding-top: 46px;
        // padding-bottom: 46px;
        padding-left: 25px;
        .image {
           width: 100%;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.home-carousel {
  height: 800px;
  .el-carousel__container {
    height: 800px !important;
  }
  .el-carousel__item {
    width: 100%;
    height: 800px;
  }
  .carousel-box {
    position: relative;
    width: 100%;
    .carousel-bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 800px;
      .carousel-img {
        width: 100%;
        height: 100%;
      }
    }
    .carousel-content,
    .carousel-content-right {
      position: absolute;
      text-align: left;
      top: 182px;
      .state {
        font-size: 24px;
        color: rgba(255, 255, 255, 0.8);
      }
      .title {
        margin-top: 20px;
        font-weight: 700;
        font-size: 60px;
        color: #ffffff;
      }
      .desc {
        margin-top: 10px;
        font-size: 28px;
        color: rgba(255, 255, 255, 0.8);
      }
      .num {
        margin-top: 10px;
        font-size: 16px;
        color: rgba(255, 255, 255, 0.4);
      }
      .button-box {
        width: 260px;
        height: 70px;
        cursor: pointer;
        margin-top: 40px;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        .button-img {
          .image {
            vertical-align: middle;
            width: 45px;
            height: 45px;
          }
        }
        .load-now {
          margin-left: 12px;
          font-size: 30px;
          color: #1082ff;
        }
      }
      .botom-app-box {
        display: flex;
        align-items: center;
        margin-top: 29px;
        .app-qr {
          .image {
            width: 190px;
            height: 190px;
          }
        }
        .banner-app-item-box {
          margin-left: 22px;
          .banner-app-item-top,
          .banner-app-item-bottom {
            width: 174px;
            height: 70px;
            cursor: pointer;
            text-decoration: none;
            background: #38daff;
            border-radius: 35px;
            display: flex;
            padding-left: 32px;
            padding-right: 34px;
            justify-content: space-between;
            align-items: center;
            .item-img {
              .image {
                width: 40px;
                height: 40px;
              }
            }
            .name {
              padding-left: 20px;
              font-size: 30px;
              color: #ffffff;
            }
          }
          .banner-app-item-bottom {
            margin-top: 21px;
          }
        }
      }
    }
    .carousel-content {
      left: 300px;
    }
    .carousel-content-right {
      right: 300px;
    }
  }
}
</style>






// WEBPACK FOOTER //
// src/views/Home.vue